export default {
  GET_USER_INFORMATION: '@USER_INFORMATION/GET_USER_INFORMATION',
  GET_USER_INFORMATION_SUCCESS: '@USER_INFORMATION/GET_USER_INFORMATION_SUCCESS',
  GET_USER_INFORMATION_FAILURE: '@USER_INFORMATION/GET_USER_INFORMATION_FAILURE',
  CLEAR_USER_INFORMATION: '@USER_INFORMATION/CLEAR_USER_INFORMATION',
  UPDATE_USER_INFORMATION: '@USER_INFORMATION/UPDATE_USER_INFORMATION',
  UPDATE_USER_INFORMATION_SUCCESS: '@USER_INFORMATION/UPDATE_USER_INFORMATION_SUCCESS',
  UPDATE_USER_INFORMATION_FAILURE: '@USER_INFORMATION/UPDATE_USER_INFORMATION_FAILURE',
  UPDATE_PHOTO_USER_INFORMATION: '@USER_INFORMATION/UPDATE_PHOTO_USER_INFORMATION',
  UPDATE_PHOTO_USER_INFORMATION_SUCCESS: '@USER_INFORMATION/UPDATE_PHOTO_USER_INFORMATION_SUCCESS',
  UPDATE_PHOTO_USER_INFORMATION_FAILURE: '@USER_INFORMATION/UPDATE_PHOTO_USER_INFORMATION_FAILURE',
  CHANGE_EMAIL_USER_INFORMATION: '@USER_INFORMATION/UPDATE_EMAIL_USER_INFORMATION',
  CHANGE_EMAIL_USER_INFORMATION_SUCCESS: '@USER_INFORMATION/UPDATE_EMAIL_USER_INFORMATION_SUCCESS',
  CHANGE_EMAIL_USER_INFORMATION_FAILURE: '@USER_INFORMATION/UPDATE_EMAIL_USER_INFORMATION_FAILURE',
  CHANGE_PASSWORD_USER_INFORMATION: '@USER_INFORMATION/CHANGE_PASSWORD_USER_INFORMATION',
  CHANGE_PASSWORD_USER_INFORMATION_SUCCESS: '@USER_INFORMATION/CHANGE_PASSWORD_USER_INFORMATION_SUCCESS',
  CHANGE_PASSWORD_USER_INFORMATION_FAILURE: '@USER_INFORMATION/CHANGE_PASSWORD_USER_INFORMATION_FAILURE'
}
